import {Style, Circle, Fill, Stroke, Text} from 'ol/style.js';
import {transformExtent} from 'ol/proj';
import {GeoJsonLayer} from '../GeoJsonLayer.js';
import Library from '../Library.js';

export class RadarSiteLayer extends GeoJsonLayer {
    icon_cache = {};

    constructor( map, settings = {}){
        settings["name"] = 'radarsite';
        settings["api_endpt"] = "RadarSiteJSON.php";
        if( settings['labels'] == undefined ) settings["labels"] = false;
        super( map, settings );
    }

    getUrl( extent, resolution, projection ){
        let extent1 = transformExtent(extent, projection, "EPSG:4326");
        let url = new URL( this.api_path + "/" + this.api_endpt );
        url.searchParams.set( "bbox", extent1.join(","));
        url.searchParams.set( "zoom", this.map.view.getZoom());
        return url.toString();
    }

    getColor( feature ){
        if( this.property(feature, "prior") == 4)
            return "#FF0088";
        return "#FF8800";
    }

    getLabel( feature ){
        let str = "";
        if( this.settings['labels'] == true ){
            str = Math.round(this.property(feature,'elev')*3.28)+"";
        }
        return str;
    }

    getPopupText( feature ){
        let text = this.popupTitle( "RADAR", this.property(feature,'id') );
        text += this.popupData( "Name", this.property(feature,'name') );
        text += this.popupData(  "Type", (this.property(feature, 'prior') == 4? "TDWR": "WSR") );
        let id = this.property(feature, 'id');
        let rid = "K"+id;
        if( this.property(feature, 'state') == "AK" || this.property(feature, 'state') == "HI" ) 
            rid = "P"+id;
        if( this.property(feature, 'state') == "PR" )
            rid = "T"+id;
        text += "<div style=\"position: relative; height: 175px\"><div style=\"position: absolute; left: 0; right: 0\"><img src=\"/data/obs/nids/"+id+"/latest.gif\"/></div><div style=\"position: absolute; left:0; right: 0\"><a href=\"/radar/site?id="+id+"\"><img src=\"/images/nids/"+id+"_over_sm.gif\"></a></div>";
        text += this.popupEnd();
        return text;
    }

    getStyle(feature, resolution ){
        let style = new Style({
                "image": new Circle({
                    "radius": 5,
                    "fill": new Fill({
                        "color": Library.parseHexColorToArray(this.getColor(feature), .5)
                    }),
                    "stroke": new Stroke({
                        "color": Library.parseHexColorToArray(this.getColor(feature)),
                        "width": 2
                    })
                })
            });
        return style;
    }

}
